import React from 'react';
import { withRouter } from 'react-router';

import Form from '../../../../../../../../components/Form/Form/';
import TopicSelector from '../TopicSelector/';
import Spinner from '../../../../../../../../components/Spinner/';

import './CoachingPreferences.scss';

class CoachingPreferences extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { viewer } = props.CoachingPreferencesData;
    let initialValues = viewer ? { CoachingTopics: viewer.topics.map(x => x.id), } : {};

    if (viewer && (viewer.advisor_info !== null)) {
      initialValues['Availability'] = viewer.advisor_info.typical_monthly_availability || null;
    }

    Bugsnag.leaveBreadcrumb('Coaching preferences initial values: ', JSON.stringify(initialValues, null, 2));

    this.state = {
      changeMade: false,
      saving: false,
      error: null,
      customButtonMessage: null,
      initialValues: initialValues,
      currentValues: initialValues,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.getButtonText = this.getButtonText.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  };

  routerWillLeave(nextLocation) {
    if (this.state.changeMade) {
      return 'Your work is not saved! Are you sure you want to leave?';
    }
  };

  handleChange(event) {
    window.onbeforeunload = function () {
      return true;
    };

    this.setState({
      changeMade: true,
      currentValues: event.target.value,
      customButtonMessage: null,
    });
  }

  handleSave() {
    this.setState({
      saving: true,
      error: null,
    });

    Bugsnag.leaveBreadcrumb('Saving Form with Data', JSON.stringify({
      id: this.props.CoachingPreferencesData.variables.UserID,
      MonthlyAvailable: parseInt(this.state.currentValues.Availability),
      TopicIDs: this.state.currentValues.CoachingTopics,
    }, null, 2));

    this.props.SubmitData({
      variables: {
        id: this.props.CoachingPreferencesData.variables.UserID,
        MonthlyAvailable: parseInt(this.state.currentValues.Availability),
        TopicIDs: this.state.currentValues.CoachingTopics,
      }
    }).then(() => {
      Bugsnag.leaveBreadcrumb('Sucessfully saved Coaching preferences');
      window.onbeforeunload = null;
      this.setState({
        saving: false,
        changeMade: false,
        initialValues: this.state.currentValues,
        customButtonMessage: 'Saved Successfully',
      });
    }).catch((error) => {
      props.AboutUserData.AdvisorInfo('Error while saving Coaching preferences: ', error);
      Bugsnag.notifyException(error);

      this.setState({
        saving: false,
        error: error
      });
    });
  }

  getButtonText() {
    if (this.state.customButtonMessage !== null) {
      return this.state.customButtonMessage;
    }

    if (this.state.saving) {
      return <Spinner className='spinner--white' />;
    }

    if (this.state.changeMade === false) {
      return 'No Changes made';
    }

    return 'Save';
  }

  render() {
    return (
      <div className='ProfileCoachingPreferences'>
        <h1>Profile Education</h1>
        <Form defaultValue={this.state.initialValues} onChange={this.handleChange}>
          <div className='row'>
            <div className='col-md'>
              <div className='Form__inputWrap'>
                <label className='Form__InputLabel'>Prefered coaching topics</label>
                <br />
                <small>What topics would you enjoy coaching?</small>
                <br />
                <TopicSelector name='CoachingTopics' Topics={this.props.CoachingPreferencesData.TopicCategories} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md'>
              <hr />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-7'>
              <div className='Form__inputWrap'>
                <label className='Form__InputLabel'>Typical Monthly Availability</label>
                <br />
                <small>We will confirm with you before scheduling an actual student session</small>
                <br />
                <select className='Form__Input Form__Input--white' name='Availability'>
                  <option value='0'>I’m not ready or need to pause my advising for now</option>
                  <option value='2'>I’m comfortable dedicating 1-2 hours a month</option>
                  <option value='4'>I’m comfortable dedicating 3-4 hours a month</option>
                  <option value='6'>I’m comfortable dedicating 5+ hours a month</option>
                </select>
              </div>
            </div>
          </div>
        </Form>
        <button disabled={this.state.changeMade === false && this.state.saving === false} onClick={this.handleSave} className='CoachingPreferences__button'>
          {this.getButtonText()}
        </button>
      </div>
    );
  }
}

export default CoachingPreferences;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/CoachingPreferences/components/CoachingPreferences/index.js